<!-- event Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

<div
  class="event-header"
  style="background-image: url(assets/image/Group-1892.png)"
>
  <div class="event-heading">
    <div class="event-head">
      <h3>MY ACCOUNT</h3>
    </div>
  </div>
</div>


<!-- donation details -->

<div class="account-session">
    <div class="container">
      
       <div class="form-content">
        <form  #userlogin="ngForm" (ngSubmit)="onClickSubmit(userlogin.value)">
            <div class="form-row">
              <div class="col-md-12">
                <p><span>Selected Plan: </span>  {{planinfo}}</p> 
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" placeholder="User name"  readonly value="{{getusername}}">
              </div>
              <div class="col-md-6">
                <input type="password" class="form-control formcontent" placeholder="**********" readonly value="{{getpassword}}" >
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control  formcontent" required placeholder="First Name *" name="Firstname" [ngModel] >
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" required placeholder="Last Name *" name="lastName" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" required placeholder="Email *"  name="email"  [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent"  required placeholder="Phone *" name=Phone [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" required placeholder="Address 1 *" name="address1" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent"  required placeholder="Address 2 *" name="address2" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" required placeholder="Zip" name="zip" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" placeholder="City" name="city" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" placeholder="State" name="state" [ngModel]>
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control formcontent" placeholder="Country *" name="Country" [ngModel]>
              </div>
              <div class="col-md-6">
                <label for="sel1">Add to the member directory?</label>  <label class="mx-2 radio-inline"><input  type="radio" name="optradio"  [value]="1"  [ngModel]='checkvalue'>Yes</label>
<label class="radio-inline"> <input type="radio" name="optradio"   [value]="0"     required   [ngModel]='checkvalue'>No</label>
              </div>
              <div class="col-md-6">
            
              </div>
              <div class="col-md-12 accept">
                <label class="checkbox-inline"><input type="checkbox" value="true" (change)="getaccept($event.target.value)">  <a class="ml-2" target="_blank" routerLink="/privacy" >Accept our Terms & Conditions</a></label>
                </div>
           
      
              <div class="btn-contents">
                 <input type="submit" class="btn-cont" value="REGISTER">

              </div>
            </div>
          </form>
       </div>
    </div>

</div>